module.exports = __webpack_public_path__ + "img/header-logo.c00b552.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/header-logo.svg
// module id = ./static/images/header-logo.svg
// module chunks = 5